import { render, staticRenderFns } from "./JeecgDemoTabsModal.vue?vue&type=template&id=0a5d7772&scoped=true&"
import script from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
export * from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgDemoTabsModal.vue?vue&type=style&index=0&id=0a5d7772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d7772",
  null
  
)

export default component.exports